export default "__VITE_ASSET__BzpGpSlV__"